import React from 'react'
import PropTypes from 'prop-types'
import styles from './TableSlatePlugin.scss'
import { ButtonGroup, Button, UncontrolledTooltip } from 'reactstrap'
import { FaTrash } from 'react-icons/lib/fa'
import EditorTooltip from '../EditorTooltip'
import * as TablePosition from './deep-table-plugin/TablePosition'
import InsertEmptySpaceButton from '../InsertEmptySpaceButton'

class GridTableRow extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
    this.uid = Date.now()
  }

  getCurrentRow = state => {
    return state.document.getClosest(
      state.startBlock.key,
      (p) => (p.type === this.props.opts.typeRow)
    )
  }

  render () {
    const { actions, attributes, node, children, readOnly, state, editor: { onChange }, opts } = this.props
    const closestRow = this.getCurrentRow(state)
    const pos = TablePosition.create(state, state.startBlock, opts)
    const focusedOnCurrentNode = closestRow && node.key === closestRow.key
    const showTooltip = !readOnly && focusedOnCurrentNode
    const cellWidth = (100 / children.length) + '%'
    const cells = React.Children.map(children, child => {
      const newNode = child.props.node.setIn(['data', 'width'], cellWidth)
      return React.cloneElement(child, {
        node: newNode
      })
    })
    const uid = 'GridTableRow' + this.uid
    return <tr {...attributes}
      id={uid}
      className={styles.GridTableRow}>
      <EditorTooltip placement='top' className={styles.TableActionsTooltip} isOpen={showTooltip} target={uid} toggle={this.toggle} state={state}>
        <div>
          <ButtonGroup style={{marginBottom: '10px'}}>
            <Button
              onClick={e => onChange(actions.onInsertRow(e, state))}
              color='secondary'
              > <strong>Insert</strong> row
            </Button>
            <Button
              onClick={e => onChange(actions.onRemoveRow(e, state))}
              color='secondary'
              > <strong>Remove</strong> row
            </Button>
          </ButtonGroup>
          <br />
          <ButtonGroup style={{marginBottom: '10px'}}>
            <Button
              onClick={e => onChange(actions.onInsertColumn(e, state))}
              color='secondary'
              > <strong>Insert</strong> column
            </Button>
            <Button
              onClick={e => onChange(actions.onRemoveColumn(e, state))}
              color='secondary'
              > <strong>Remove</strong> column
            </Button>
          </ButtonGroup>
          <br />
          <ButtonGroup>
            {
              pos.table && (pos.isFirstRow() || pos.isLastRow()) &&
              <InsertEmptySpaceButton
                before={pos.isFirstRow()}
                after={pos.isLastRow()}
                block={pos.table}
                state={state}
                onChange={onChange} />
            }
            <Button id={uid + 'trash'} onClick={e => onChange(actions.onRemoveTable(e, state))} color='danger'><FaTrash /></Button>
            <UncontrolledTooltip target={uid + 'trash'}>Remove Grid</UncontrolledTooltip>
          </ButtonGroup>
        </div>
      </EditorTooltip>
      {cells}
    </tr>
  }
}

GridTableRow.propTypes = {
  opts: PropTypes.object,
  actions: PropTypes.object,
  attributes: PropTypes.object,
  node: PropTypes.object,
  readOnly: PropTypes.bool,
  state: PropTypes.object,
  editor: PropTypes.object,
  children: PropTypes.node
}

export default GridTableRow



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/GridTableRow.js